import qs from "qs";

import { SubscriptionClient } from "./BaanRueJaiClient/subscriptions";
import { UserClient } from "./BaanRueJaiClient/users";
import { MemberManagementClient } from "./BaanRueJaiClient/member-management";
import { CommunicationClient } from "./BaanRueJaiClient/communications";
import { ProjectClient } from "./BaanRueJaiClient/projects";
import { ProjectInstructionProgressClient } from "./BaanRueJaiClient/projectInstructionProgress";
import { AddressClient } from "./BaanRueJaiClient/addresses";
import { HomeAutomationClient } from "./BaanRueJaiClient/home-automation";
import { GreetingClient } from "./BaanRueJaiClient/greeting";
import { HomeClient } from "./BaanRueJaiClient/homes";
import { InsuranceClient } from "./BaanRueJaiClient/insurance";
import { FinancialInstitutionClient } from "./BaanRueJaiClient/financial-institution";
import { MonitoringClient } from "./BaanRueJaiClient/monitorings";
import { RuejaiClubClient } from "./BaanRueJaiClient/ruejai-club";
import { ConversationsClient } from "./BaanRueJaiClient/conversations";
import { ResidentClient } from "./BaanRueJaiClient/resident";
import { ArticleClient } from "./BaanRueJaiClient/article";
import { Lead } from "./BaanRueJaiClient/lead";
import { GroupClient } from "./BaanRueJaiClient/group";
import { JuristicFeatureClient } from "./BaanRueJaiClient/juristic-feature";
import { EvClient } from "./BaanRueJaiClient/ev";
import { BannerClient } from "./BaanRueJaiClient/banner";
import { Sap } from "./BaanRueJaiClient/sap";
import { Tokenx } from "./BaanRueJaiClient/tokenx";
import { ContactClient } from "./BaanRueJaiClient/contact";
import { OtherClient } from "./Client/OtherClient";
import { LogClient } from "./BaanRueJaiClient/log"
import { LineNotify } from "./BaanRueJaiClient/line-notify";
import { FeedbackClient } from "./BaanRueJaiClient/feedbacks";
import { Redeem } from './BaanRueJaiClient/redeem'
import { Payment } from './BaanRueJaiClient/payment'

/* eslint-disable */
class AuthClient {
  /**
   *
   * @param {import('./HTTPClient').HTTPClient} httpClient
   * @param {string} baseURL
   */
  constructor(httpClient, baseURL) {
    this.httpClient = httpClient;
    this.baseURL = `${baseURL}/auth`;
  }

  retoken() {}
}

class AdminClient {

  /**
   *
   * @param {import('./HTTPClient').HTTPClient} httpClient
   * @param {string} baseURL
   */
  constructor(httpClient, baseURL) {
    this.httpClient = httpClient;
    this.baseURL = baseURL;

    this.banner = new BannerClient(httpClient, baseURL);
    this.auth = new AuthClient(httpClient, baseURL);
    this.subscriptions = new SubscriptionClient(httpClient, baseURL);
    this.communications = new CommunicationClient(httpClient, baseURL);
    this.greeting = new GreetingClient(httpClient, baseURL);
    this.homes = new HomeClient(httpClient, baseURL);
    this.projects = new ProjectClient(httpClient, baseURL);
    this.projectInstructionProgress = new ProjectInstructionProgressClient(
      httpClient,
      baseURL.replace("/api", "")
    );
    this.users = new UserClient(httpClient, baseURL);
    this.addresses = new AddressClient(httpClient, baseURL);
    this.memberManagement = new MemberManagementClient(
      httpClient,
      baseURL.replace("/api", "")
    );
    this.homeAutomation = new HomeAutomationClient(
      httpClient,
      baseURL.replace("/api", "")
    );
    this.insurances = new InsuranceClient(httpClient, baseURL);
    this.financialInstitution = new FinancialInstitutionClient(httpClient, baseURL);
    this.monitorings = new MonitoringClient(httpClient, baseURL);
    this.ruejaiClub = new RuejaiClubClient(httpClient, baseURL);
    this.conversations = new ConversationsClient(httpClient, baseURL);
    this.residents = new ResidentClient(httpClient, baseURL);
    this.articles = new ArticleClient(httpClient, baseURL);
    this.groups = new GroupClient(httpClient, baseURL);
    this.juristicFeature = new JuristicFeatureClient(httpClient, baseURL);
    this.ev = new EvClient(httpClient, baseURL);
    this.feedbacks = new FeedbackClient(httpClient, baseURL);
    this.sap = new Sap(httpClient, baseURL);
    this.lead = new Lead(httpClient, baseURL);
    this.tokenx = new Tokenx(httpClient, baseURL);
    this.contacts = new ContactClient(httpClient, baseURL);
    this.log = new LogClient(httpClient, baseURL);
    this.lineNotify = new LineNotify(httpClient, baseURL)
    this.redeem = new Redeem(httpClient, baseURL)
    this.payment = new Payment(httpClient, baseURL)
  }
}

export class BaanRueJaiClient {
  /**
   *
   * @param {import('./HTTPClient').HTTPClient} httpClient
   */
  constructor(httpClient) {
    this.httpClient = httpClient;
    this.admin = new AdminClient(httpClient, "/api/admin");
    this.others = new OtherClient(httpClient, "/api");
  }

  async downloadImage(imageKey) {
    try {
      const response = await this.httpClient.request('GET', '/api/downloads/image', {
        params: {
          imageKey,
        },
      });

      return response;
    } catch (error) {
      console.debug('Download image failed with key:', imageKey);
    }
  }

  /**
   *
   * @param {string} token
   * @return {void}
   */
  setAuthorizationToken(token) {
    const key = "Authorization";
    const value = token ? `Bearer ${token}` : undefined;

    this.httpClient.setHeader(key, value);
  }
}



// WEBPACK FOOTER //
// ./src/clients/BaanRueJaiClient.js